type Traductor = (k: string, o?: Record<string, unknown>) => string;

const humanitza = (s: string) => s.replace(/[_-]/g, ' ').toLowerCase();

/**
 * Text llegible d'una acció d'auditoria. El servidor registra codis com «document.alta»,
 * «activacio.tancar» o «PERMIS_DENEGAT»: es tradueixen l'entitat i el verb per separat.
 */
export function textAccioAuditoria(accio: string, t: Traductor): string {
  const segments = accio.split('.');
  const entitat =
    segments.length > 2 && segments[0] === 'organitzacio'
      ? (segments[1] ?? null)
      : segments.length > 1
        ? (segments[0] ?? null)
        : null;
  const verb = segments.length > 1 ? (segments.at(-1) ?? accio) : accio;
  const especifica = t(`auditoria.accionsCompletes.${accio.replace(/[.-]/g, '_')}`, {
    defaultValue: '',
  });
  if (especifica) return especifica;
  const v = t(`auditoria.accions.${verb ?? ''}`, {
    defaultValue: t(`auditoria.verbs.${(verb ?? '').toLowerCase()}`, {
      defaultValue: humanitza(verb ?? accio),
    }),
  });
  if (!entitat) return v;
  return `${v} · ${textEntitatAuditoria(entitat, t)}`;
}

export function textEntitatAuditoria(entitat: string, t: Traductor): string {
  const e = entitat.toLowerCase();
  return t(`auditoria.entitats.${e}`, { defaultValue: humanitza(e) });
}
